<template>
  <div class="table-tdrow">
    <div class="table-td wp20">{{d.code}}</div>
    <div class="table-td w120">
      <Ellipsis v-if="d.name"
      :text="d.name"
      :length="15" />
    </div>
    <div class="table-td wp20">{{d.cost_center}}</div>
    <div class="table-td wp20">{{d.contribution ? d.contribution.toFixed(2) : 0}}</div>
  </div>
</template>

<script>
export default {
  props: ['d'],
};
</script>

